// src/pages/Cybersecurity.js

import React from 'react';

const Cybersecurity = () => {
  return (
    <div>
      <div className='main'>
        <div className="column1"></div>
        <div className="column2">
          <br />
          <br />
          <div style={{ textAlign: 'center' }}>
            <h1>Sabrenetics ISO 27001 policy</h1>
          </div>
          <p>
            Effective as of March 5th, 2024, Sabrenetics PTY LTD acknowledges its commitment to information security by adhering 
            to the principles and requirements outlined in ISO 27001. Our Information Security Management System (ISMS) has been 
            established to manage and protect our information assets through the implementation of policies, procedures, 
            processes, and controls.
          </p>
          <p>
            Please note that while our ISMS is designed to align with ISO 27001 standards, we have not yet undergone an official 
            external audit for certification. An external audit gap analysis has not been performed at this time.
          </p>
          <p>
            We are continuously working towards formal certification to demonstrate our commitment to maintaining robust 
            information security practices and meeting internationally recognized standards.
          </p>
          <br />
        </div>
        <div className="column3"></div>
      </div>
    </div>
  );
};

export default Cybersecurity;
